export default {
  title: {
    messageManagement: '消息管理',
    notificationManagement: '通知模板管理',
    notificationEdit: '编辑消息',
    notificationAdd: '添加消息',
    notificationView: '查看消息',
    layoutTemplateManagement: '模板管理',
    layoutEdit: '编辑模板',
    layoutAdd: '添加模板',
    layoutView: '查看模板'
  },
  label: {
    emailSenderAddress: '发件邮箱地址',
    toEmailAddress: '接收邮件地址',
    senderEmailCn: '发件人名称（中文）',
    senderEmailEn: '发件人名称（英文）',
    subject: '邮件主题',
    subjectCn: '邮件主题（中文）',
    subjectEn: '邮件主题（英文）',
    emailEdit: '邮件正文',
    emailEditCn: '邮件正文（中文）',
    emailEditEn: '邮件正文（英文）',
    emailTemplateCn: '邮件模板（中文）',
    emailTemplateEn: '邮件模板（英文）',
    templateType: '消息类型',
    templateName: '消息名称',
    layoutName: '模板名称',
    layoutTemplateList: '模板管理',
    layoutTemplateLoad: '模板',
    emailHeader: '邮件页眉',
    emailFooter: '邮件页脚',
    backTemplatePage: '消息管理',
    searchTemplateName: '消息名称',
    searchTemplateType: '消息类型',
    receiverLimit: '收件人单日邮件限制',
    edit: '编辑',
    delete: '删除',
    companyName: '公司名称',
    searchUpLayout: '从母公司继承'
  },
  tabMenu: {
    messageManagement: '消息管理',
    layoutTemplateManagement: '模板管理'
  },
  message: {
    sendSuccess: '发送成功',
    deleteTip: '确定删除吗?',
    deleteLayout: '确定删除{company} - {name}模板吗？'
  },
  btn: {
    sendEmailTestButton: '发送测试邮件',
    cancel: '取消',
    save: '保存',
    send: '发送'
  }
}
